import { render, staticRenderFns } from "./public_layout.vue?vue&type=template&id=31d082e4&"
import script from "./public_layout.vue?vue&type=script&lang=js&"
export * from "./public_layout.vue?vue&type=script&lang=js&"
import style0 from "./public_layout.vue?vue&type=style&index=0&id=31d082e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports